import { Flex, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import { APPLY_MAIL } from '@/constants/constants';
import { AppliedStub } from '@/pages/apply/components/AppliedStub/AppliedStub';
import { ApplyForm } from '@/pages/apply/components/ApplyForm/ApplyForm';
import { NoDiscordStub } from '@/pages/apply/components/NoDiscordStub/NoDiscordStub';
import { UnauthorizedStub } from '@/pages/apply/components/UnauthorizedStub/UnauthorizedStub';
import styles from './ApplyPage.module.css';
import PlaneIcon from './svg/plane.svg?react';

const Stub = () => {
    const { user } = usePageContext();

    if (!user)
        return <UnauthorizedStub />;
    if (!user.has_discord)
        return <NoDiscordStub />;
    if (user.role !== 'pilot')
        return <AppliedStub />;

    return null;
};

export const Page = () => {
    const { user } = usePageContext();
    const { t } = useTranslation();

    const showStub = !user || !user.has_discord || user.role !== 'pilot';

    return (
        <Flex gap={64} justify="center" className={styles.container}>
            <article className={styles.description}>
                <Typography.Heading color="textPrimary">{t('Apply_Info_Title')}</Typography.Heading>
                <Typography.Paragraph>
                    {t('Apply_Info_FirstParagraph')}
                    <br />
                    <br />
                    {t('Apply_Info_SecondParagraph_FirstPart')}
                    <a href={`mailto:${APPLY_MAIL}`} className={styles.mail}>{APPLY_MAIL}</a>
                    {'. '}
                    {t('Apply_Info_SecondParagraph_SecondPart')}
                </Typography.Paragraph>
                <PlaneIcon className={styles.plane} />
            </article>
            <Flex data-user-allowed={!showStub} justify="center" align="center" flex="1 0" className={styles.action}>
                <ApplyForm />
                {Boolean(showStub) && (
                    <Flex vertical justify="center" align="center" flex="1 0" gap={30} className={styles.stub}>
                        <Stub />
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};
